module.exports = __webpack_public_path__ + "static/media/5.b47a2f25.jpg";